var path = 'src/app/auth/random-password.html';
var html = "<div ng-if=loading> Generating <i class=\"fa fa-spinner fa-spin\"></i> </div> <div ng-if=!loading> <div ng-if=password> <span class=password>{{password}}</span> <button ng-click=generate() type=button class=\"btn btn-primary btn-xs\"><i class=\"fa fa-refresh\"></i></button> </div> <div ng-if=!password> <button ng-click=generate() type=button class=\"btn btn-primary btn-xs\">Generate Password</button> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/random-password.html
 ** module id = 32
 ** module chunks = 0
 **/